<ng-container *ngIf="cmsDataService.configuration.sponsorship">
<p>{{ cmsDataService.configuration.sponsorship.attribution }}</p>
<div class="logo">
	<img alt="" [src]="cmsDataService.configuration.sponsorship.logoURL[logoKey] || '' | getDownloadURL">
</div>
</ng-container>